/* Web Slinger — interactions du thème (vanilla JS, sans dépendance) */
(function () {
  'use strict';

  var routes = (window.theme && window.theme.routes) || {};

  /* ---------- Formatage monétaire (reproduit le filtre Liquid money) ---------- */
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? ',' : thousands;
    decimal = decimal == null ? '.' : decimal;
    if (isNaN(number) || number == null) return '0';
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  function formatMoney(cents, format) {
    cents = parseInt(cents, 10) || 0;
    format = format || (window.theme && window.theme.moneyFormat) || '{{amount}} €';
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholder);
    if (!match) return format;
    switch (match[1]) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }
  window.theme = window.theme || {};
  window.theme.formatMoney = formatMoney;

  /* ---------- Utilitaires ---------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function fetchJSON(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json' } }, opts)).then(function (r) { return r.json(); });
  }
  function trapFocus(container) {
    var focusables = qsa('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])', container);
    if (!focusables.length) return function () {};
    var first = focusables[0], last = focusables[focusables.length - 1];
    function handler(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', handler);
    first.focus();
    return function () { container.removeEventListener('keydown', handler); };
  }

  /* ---------- Barre d'annonce : rotation ---------- */
  function initAnnouncement() {
    var bar = qs('[data-announcement]');
    if (!bar) return;
    var items = qsa('.announcement__item', bar);
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4200);
  }

  function initOfferNotice() {
    var notice = qs('[data-offer-notice]');
    var close = qs('[data-offer-notice-close]', notice);
    if (!notice || !close) return;
    close.addEventListener('click', function () {
      notice.classList.add('is-hidden');
    });
  }

  /* ---------- Menu mobile ---------- */
  function initMobileMenu() {
    var menu = qs('[data-mobile-menu]');
    var openBtn = qs('[data-menu-toggle]');
    if (!menu || !openBtn) return;
    var release = null;
    function open() {
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('no-scroll');
      release = trapFocus(menu);
    }
    function close() {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('no-scroll');
      if (release) release();
      openBtn.focus();
    }
    openBtn.addEventListener('click', open);
    qsa('[data-menu-close]', menu).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && menu.classList.contains('is-open')) close(); });
  }

  /* ---------- Recherche : panneau ---------- */
  function initSearchPanel() {
    var toggle = qs('[data-search-toggle]');
    var panel = qs('[data-search-panel]');
    if (!toggle || !panel) return;
    toggle.addEventListener('click', function () {
      var isHidden = panel.hasAttribute('hidden');
      if (isHidden) {
        panel.removeAttribute('hidden');
        toggle.setAttribute('aria-expanded', 'true');
        var input = qs('input[type="search"]', panel);
        if (input) input.focus();
      } else {
        panel.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---------- Panier latéral ---------- */
  var Cart = (function () {
    var drawer = qs('[data-cart-drawer]');
    var release = null;

    function render(html) {
      if (!drawer) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var fresh = tmp.querySelector('[data-cart-drawer]');
      if (fresh) drawer.replaceWith(fresh), drawer = fresh;
      bindLines();
      syncCount();
    }

    function refresh() {
      fetch(window.location.pathname + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-cart-drawer]');
          if (fresh) { drawer.innerHTML = fresh.innerHTML; }
          bindLines();
        });
    }

    function syncCount() {
      fetchJSON(routes.cart + '.js').then(function (cart) {
        qsa('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        qsa('[data-cart-count-inline]').forEach(function (el) { el.textContent = cart.item_count; });
      });
    }

    function open() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('no-scroll');
      release = trapFocus(drawer);
    }
    function close() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('no-scroll');
      if (release) release();
    }

    function busy(state) { if (drawer) drawer.classList.toggle('is-busy', state); }

    function changeLine(line, quantity) {
      busy(true);
      fetchJSON(routes.cartChange + '.js', {
        method: 'POST',
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function () { reloadDrawerMarkup(); }).catch(function () { busy(false); });
    }

    function reloadDrawerMarkup() {
      fetch('/?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var freshInner = tmp.querySelector('[data-cart-drawer]');
          if (freshInner && drawer) {
            drawer.innerHTML = freshInner.innerHTML;
            drawer.classList.add('is-open');
          }
          bindLines();
          syncCount();
          busy(false);
        });
    }

    function bindLines() {
      if (!drawer) return;
      qsa('[data-qty][data-line]', drawer).forEach(function (box) {
        var line = box.getAttribute('data-line');
        var input = qs('input', box);
        qsa('[data-qty-btn]', box).forEach(function (btn) {
          btn.addEventListener('click', function () {
            var next = Math.max(0, parseInt(input.value || '0', 10) + parseInt(btn.getAttribute('data-qty-btn'), 10));
            changeLine(line, next);
          });
        });
      });
      qsa('[data-line-remove]', drawer).forEach(function (btn) {
        btn.addEventListener('click', function () { changeLine(btn.getAttribute('data-line-remove'), 0); });
      });
      qsa('[data-drawer-close]', drawer).forEach(function (btn) { btn.addEventListener('click', close); });
      var overlay = qs('.drawer__overlay', drawer);
      if (overlay) overlay.addEventListener('click', close);
    }

    function addItem(variantId, quantity, onDone) {
      fetchJSON(routes.cartAdd, {
        method: 'POST',
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
      }).then(function (res) {
        reloadDrawerMarkup();
        if (onDone) onDone(res);
      }).catch(function () { if (onDone) onDone(null); });
    }

    if (drawer) bindLines();
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) close(); });

    return { open: open, close: close, addItem: addItem, syncCount: syncCount, refresh: reloadDrawerMarkup };
  })();

  function initCartOpeners() {
    qsa('[data-cart-open]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        Cart.open();
      });
    });
  }

  /* ---------- Ajout rapide depuis les cartes produit ---------- */
  function initQuickAdd() {
    qsa('[data-quick-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = btn.getAttribute('data-variant-id');
        btn.classList.add('is-loading');
        Cart.addItem(variantId, 1, function () { btn.classList.remove('is-loading'); });
      });
    });
  }

  function updateCart(form) {
    var updateUrl = routes.cartUpdate;
    if (!form || !updateUrl) return;
    form.classList.add('is-loading');
    fetch(updateUrl + '.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart update failed');
      return response.json();
    }).then(function () {
      window.location.reload();
    }).catch(function () {
      form.classList.remove('is-loading');
    });
  }
  window.theme.updateCart = updateCart;

  /* ---------- Formulaire produit (page produit) ---------- */
  function initProductForm() {
    qsa('[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = qs('[data-atc]', form);
        var errorBox = qs('[data-form-error]', form);
        var offerEnabled = form.getAttribute('data-offer-enabled') === 'true';
        var offerCode = form.getAttribute('data-offer-code');
        var quantityInput = qs('input[name="quantity"]', form);
        var quantity = quantityInput ? Math.max(1, parseInt(quantityInput.value || '1', 10)) : 1;
        if (btn) btn.classList.add('is-loading');
        if (errorBox) errorBox.hidden = true;
        var fd = new FormData(form);
        fetch(routes.cartAdd + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
          .then(function (res) {
            if (btn) btn.classList.remove('is-loading');
            if (!res.ok) {
              if (errorBox) { errorBox.textContent = res.data.description || 'Impossible d\'ajouter ce produit au panier.'; errorBox.hidden = false; }
              return;
            }
            if (offerEnabled && offerCode && quantity >= 4) {
              var discountUrl = '/discount/' + encodeURIComponent(offerCode) + '?redirect=' + encodeURIComponent(routes.cart);
              window.location.assign(discountUrl);
              return;
            }
            Cart.syncCount();
            Cart.refresh();
          })
          .catch(function () {
            if (btn) btn.classList.remove('is-loading');
            if (errorBox) { errorBox.textContent = 'Une erreur est survenue. Réessaie.'; errorBox.hidden = false; }
          });
      });
    });
  }

  /* ---------- Sélecteur de variantes ---------- */
  function initVariantPicker() {
    qsa('[data-product]').forEach(function (section) {
      var jsonEl = qs('[data-product-json]', section);
      if (!jsonEl) return;
      var product = JSON.parse(jsonEl.textContent);
      var optionInputs = qsa('[data-option] input', section);
      if (!optionInputs.length) return;

      function currentSelection() {
        var selection = [];
        qsa('[data-option]', section).forEach(function (fieldset) {
          var checked = qs('input:checked', fieldset);
          selection.push(checked ? checked.value : null);
        });
        return selection;
      }

      function findVariant(selection) {
        return product.variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selection[i]; });
        });
      }

      function updateUI(variant) {
        var hiddenInput = qs('[data-variant-id]', section);
        var priceBox = qs('[data-price]', section);
        var atcBtn = qs('[data-atc]', section);
        var atcLabel = qs('[data-atc-label]', section);

        if (variant) {
          if (hiddenInput) { hiddenInput.value = variant.id; hiddenInput.disabled = false; }
          if (priceBox) {
            var html = '<span class="price__now">' + formatMoney(variant.price) + '</span>';
            if (variant.compare_at_price > variant.price) {
              html += '<s class="price__was">' + formatMoney(variant.compare_at_price) + '</s>' +
                '<span class="badge badge--inline">-' + Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100) + ' %</span>';
            }
            priceBox.innerHTML = html;
          }
          if (atcBtn) atcBtn.disabled = !variant.available;
          if (atcLabel) atcLabel.textContent = variant.available ? 'Ajouter au panier' : 'Épuisé';

          if (variant.featured_media) {
            var target = qs('[data-media-id="' + variant.featured_media.id + '"]', section);
            if (target) {
              qsa('.gallery__slide', section).forEach(function (s) { s.classList.remove('is-active'); });
              qsa('.thumb', section).forEach(function (t) { t.classList.remove('is-active'); });
              target.classList.add('is-active');
              var thumb = qs('.thumb[data-media-target="' + variant.featured_media.id + '"]', section);
              if (thumb) thumb.classList.add('is-active');
            }
          }
        } else {
          if (hiddenInput) hiddenInput.disabled = true;
          if (atcBtn) atcBtn.disabled = true;
          if (atcLabel) atcLabel.textContent = 'Indisponible';
        }

        var url = new URL(window.location.href);
        if (variant) { url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
      }

      function formatMoney(cents) {
        return window.theme && window.theme.formatMoney
          ? window.theme.formatMoney(cents)
          : '' + (cents / 100).toFixed(2) + ' €';
      }

      optionInputs.forEach(function (input) {
        input.addEventListener('change', function () { updateUI(findVariant(currentSelection())); });
      });
    });
  }

  /* ---------- Galerie produit : miniatures ---------- */
  function initGallery() {
    qsa('[data-gallery]').forEach(function (gallery) {
      qsa('[data-media-target]', gallery).forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var id = thumb.getAttribute('data-media-target');
          qsa('.gallery__slide', gallery).forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-media-id') === id); });
          qsa('.thumb', gallery).forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
        });
      });
    });
  }

  /* ---------- Quantité : page panier ---------- */
  function initCartPageQty() {
    qsa('.cart-line [data-qty]').forEach(function (box) {
      var input = qs('input', box);
      var form = qs('[data-cart-form]');
      qsa('[data-qty-btn]', box).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var next = Math.max(0, parseInt(input.value || '0', 10) + parseInt(btn.getAttribute('data-qty-btn'), 10));
          input.value = next;
          if (form && window.theme && window.theme.updateCart) window.theme.updateCart(form);
        });
      });
    });
  }

  /* ---------- Quantité : page produit ---------- */
  function initGenericQty() {
    qsa('.product__buy [data-qty]').forEach(function (box) {
      var input = qs('input', box);
      qsa('[data-qty-btn]', box).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var next = Math.max(1, parseInt(input.value || '1', 10) + parseInt(btn.getAttribute('data-qty-btn'), 10));
          input.value = next;
        });
      });
    });
  }

  function initReviewsCarousel() {
    qsa('[data-reviews-carousel]').forEach(function (carousel) {
      var viewport = qs('[data-reviews-viewport]', carousel);
      if (!viewport) return;
      var dragging = false;
      var moved = false;
      var startX = 0;
      var startScroll = 0;
      window.requestAnimationFrame(function () {
        viewport.scrollLeft = Math.max(0, (viewport.scrollWidth - viewport.clientWidth) / 2);
      });
      viewport.addEventListener('pointerdown', function (event) {
        if (event.target.closest('[data-review-image]')) return;
        dragging = true;
        moved = false;
        startX = event.clientX;
        startScroll = viewport.scrollLeft;
        viewport.classList.add('is-dragging');
        viewport.setPointerCapture(event.pointerId);
      });
      viewport.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        var distance = event.clientX - startX;
        if (Math.abs(distance) > 4) moved = true;
        viewport.scrollLeft = startScroll - distance;
      });
      function stopDragging(event) {
        if (!dragging) return;
        dragging = false;
        viewport.classList.remove('is-dragging');
        if (event.pointerId) viewport.releasePointerCapture(event.pointerId);
      }
      viewport.addEventListener('pointerup', stopDragging);
      viewport.addEventListener('pointercancel', stopDragging);
      viewport.addEventListener('click', function (event) {
        if (moved) {
          event.preventDefault();
          event.stopPropagation();
          moved = false;
        }
      }, true);
    });
  }

  function initReviewPreview() {
    qsa('[data-reviews-carousel]').forEach(function (carousel) {
      var preview = qs('[data-review-preview]', carousel);
      var previewImage = qs('[data-review-preview-image]', preview);
      if (!preview || !previewImage) return;
      function close() { preview.hidden = true; document.body.classList.remove('no-scroll'); }
      qsa('[data-review-image]', carousel).forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.stopPropagation();
          previewImage.src = button.getAttribute('data-review-image');
          previewImage.alt = qs('img', button).alt;
          preview.hidden = false;
          document.body.classList.add('no-scroll');
        });
      });
      qsa('[data-review-preview-close]', preview).forEach(function (button) { button.addEventListener('click', close); });
      document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && !preview.hidden) close(); });
    });
  }

  /* ---------- Filtres de collection (mobile) ---------- */
  function initFacets() {
    var toggle = qs('[data-facets-toggle]');
    var panel = qs('[data-facets-panel]');
    if (!toggle || !panel) return;
    toggle.addEventListener('click', function () {
      var open = panel.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    var form = qs('[data-facets]');
    if (form) {
      qsa('input[type="checkbox"], input[type="number"]', form).forEach(function (input) {
        input.addEventListener('change', function () { form.submit(); });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAnnouncement();
    initOfferNotice();
    initMobileMenu();
    initSearchPanel();
    initCartOpeners();
    initQuickAdd();
    initProductForm();
    initVariantPicker();
    initGallery();
    initCartPageQty();
    initGenericQty();
    initReviewsCarousel();
    initReviewPreview();
    initFacets();
  });
})();
